import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let RowBack = class RowBack extends Vue {
    onClick() {
        this.$emit('clicked');
    }
};
__decorate([
    Prop()
], RowBack.prototype, "text", void 0);
RowBack = __decorate([
    Component({})
], RowBack);
export default RowBack;
